var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.noBorder && 'noBorder',attrs:{"id":"wrapper","data-qa":_vm.qa}},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{attrs:{"id":"right-side-items"}},[_vm._t("cta"),_vm._t("actionButtons")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }